import store from "@/store";
import { debounce } from "lodash";

const refreshAuth = debounce(() => {
  store.dispatch("auth/ActionRefresh");
}, 60000);

export default async function ({ next, from, to }) {
  try {
    await store.dispatch("auth/ActionCheckToken");
  } catch (err) {}

  if (to.meta.logged_out && store.getters["auth/hasToken"]) {
    next({ name: "Home" });
  } else if (!to.meta.logged_out && !store.getters["auth/hasToken"]) {
    next({ name: "login", query: { to: to.fullPath } });
  } /* else if (!to.meta.logged_out && store.getters["auth/hasToken"]) {
    refreshAuth();
  }*/
  next();
}
